import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import { Row, Col } from 'react-flexbox-grid';
import Select from 'antd/lib/select';
import Table from 'antd/lib/table';
import DatePicker from 'antd/lib/date-picker';
import { ResponsiveTable, OpenFileLink } from '../../../common/components/data-display';
import { paymentStatus, paymentStatusT } from '../../../common/enums';
import { currencyFormatter } from '../../../common/utils/helpers';

const { Column } = Table;
const { Option } = Select;
const { RangePicker } = DatePicker;

@translate()
export default class PaymentList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    payments: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    onFilterDateRangeChange: PropTypes.func.isRequired,
    filterDateRange: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
  };

  render() {
    const {
      payments,
      pagination,
      filter,
      onTableChange,
      onFilterStatusChange,
      onFilterDateRangeChange,
      filterDateRange,
      isLoading,
      t,
      token,
    } = this.props;
    
    return (
      <div>
        <h1>{t('Platby')}</h1>

        <Row className="filters padded">
          <Col xs={12} sm={4}>
            <Select
              placeholder={t('Vybrať stav')}
              onChange={onFilterStatusChange}
              defaultValue={filter.status}
            >
              <Option value="">{t('Všetky stavy')}</Option>
              {Object.entries(paymentStatusT).filter(([key, value]) => key !== paymentStatus.PENDING).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={12} sm={4}>
            <RangePicker
              value={filterDateRange}
              onChange={onFilterDateRangeChange}
              format="DD.MM.YYYY"
            />
          </Col>
        </Row>

        <ResponsiveTable
          dataSource={payments}
          rowKey={payment => payment.id}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
        >
          <Column
            title={t('Suma')}
            dataIndex="amount"
            key="amount"
            render={amount => currencyFormatter(amount)}
          />
          <Column title={t('Variabilný symbol')} dataIndex="variableSymbol" key="variableSymbol" />
          <Column title={t('IBAN odosielateľa')} dataIndex="ibanFrom" key="ibanFrom" />
          <Column
            title={t('Stav')}
            dataIndex="status"
            key="status"
            render={status => paymentStatusT[status]}
          />
          <Column
            title={t('Akcie')}
            key="action"
            render={(text, payment) => (
              <span>
                <Link to={`/admin/payments/${payment.id}`}>{t('Detail')}</Link>
              </span>
            )}
          />
        </ResponsiveTable>

        <OpenFileLink
          isButton
          href={`${process.env.REACT_APP_API_URL}/payment/report?token=${token}&status=${filter.status}&datefrom=${filter.transferredAtStart}&dateto=${filter.transferredAtEnd}`}
        >
          {t('Export')}
        </OpenFileLink>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/components/PaymentList.js